
import {ElementRef}         from '@angular/core';

import {Dialog}              from './dialog';
import {Logger}              from '@/util/logger';
import {IValidatorCallBack}  from './i.validator.call.back';
import {IOkCallBack}         from './i.ok.call.back';
import {
  BlobType,
  Blob
}                            from '@/models/blob';
import { User }              from '@/models/user';

import * as $                from 'jquery';
import 'jquery-ui-dist/jquery-ui';

import 'jquery.fancytree/dist/modules/jquery.fancytree.dnd5';
import 'jquery.fancytree/dist/modules/jquery.fancytree.edit';
import 'jquery.fancytree/dist/modules/jquery.fancytree.glyph';
import 'jquery.fancytree/dist/modules/jquery.fancytree.wide';
import 'jquery.fancytree/dist/modules/jquery.fancytree.filter';
import 'jquery.fancytree/dist/modules/jquery.fancytree.multi';

const fancytree = require('jquery.fancytree');

import 'jquery-contextmenu';

import FancytreeNode = Fancytree.FancytreeNode;
import {first} from 'rxjs/operators';
import {ServiceManager} from "@/services/service.manager";
import {BatchPlan} from "@/models/batch/batch.plan";

/**
 *
 * @class NewCorridorBatchDialog
 *
 * @brief dialog for importing corridor batches, our job is to let the user pick a batch name
 * and a blob folder to import a batch of corridors from (i.e. was previously dropped off by
 * Ab Ovo)
 *
 * FancyTree docs:
 *
 * @link https://wwwendt.de/tech/fancytree/doc/jsdoc/index.html
 * @link https://github.com/mar10/fancytree/wiki/TutorialLoadData
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
export class NewCorridorBatchDialog extends Dialog {

  /** the name of the new batch */
  private name: string         = '';

  /** the blob file/folder we are importing from */
  private fileOrfolder: string = '';

  private type: BlobType       = BlobType.None;

  private validPlan: boolean   = false;

  /** timer to wait for user to stop typing */
  private typingTimer          = null;

  private user: User;

  private services: ServiceManager;

  /** the fancy tree object */
  private _tree = null;

  /** standard constructor, allow for partial alert to be given */
  constructor(
    host: ElementRef,
    services: ServiceManager
  ) {

    super(host);

    this.services = services;

    this.title = 'Import Corridor Batch';
    this.icon = '<i class="fas fa-plus"></i>';

    Logger.debug('[NewCorridorBatchDialog] setting up...');
  }

  /** full reset on the tree */
  private clearTree() {

    if (this._tree) {

      $('#icb-dialog-fancytree').fancytree('destroy');

      this._tree = null;
    }

  }


  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    let nbd: NewCorridorBatchDialog = this;

    nbd.validator    = validator ? validator : null;
    nbd.success      = success   ? success   : null;
    nbd.user         = this.services.projects.user();

    nbd.name         = '';
    nbd.fileOrfolder = '';

    nbd.disable();

    const    homePath: string[] = [
      '/',
      '/users',
      '/users/' + nbd.user.username
    ];

    const projectPath: string[] = [
      '/',
      '/users',
      '/users/' + nbd.user.username,
      '/users/' + nbd.user.username + '/projects'
    ];

    const quintiqPath: string[] = [
      '/incoming',
      '/incoming/quintiq'
    ];

    Logger.debug('[NewCorridorBatchDialog] opening...');

    const body = $(nbd.host).find('.modal-body');

    $(body).parent().css('min-height', '400px');

    const html = `
<div class="import-corridor-batch-dialog">

  <label id="icb-home-click" class="gui-button" title="Jump to home"><i class="fas fa-home" ></i></label>
  <label id="icb-projects-click" class="gui-button" title="Jump to Projects"><i class="fas fa-project-diagram" ></i></label>
  <label id="icb-quintiq-click" class="gui-button" title="Ab-Ovo/Qunitiq Incoming">Q</label>
  <label id="icb-hidden-click" class="gui-button" title="Show hidden files"><i class="far fa-eye-slash" ></i></label>

  <label class="gui-label" style="text-align: right; width: 70px;">Name:</label>
  <input class="gui-input batch-name-input" style="width: 200px;" type="text" placeholder="Corridor Batch Name">

</div>

<div class="icb-dialog-path" style="margin-top: 12px;">
<input
  class="gui-input icb-path-input"
  style="width: 100%;"
  type="text"
  title="Enter a path to focus on"
  placeholder="File or Folder Path">
</div>

<div
  class="icb-dialog-fancytree"
  id="icb-dialog-fancytree"
  style="margin-top: 12px; overflow: auto; display: block; height: calc(100% - 96px); max-height: 400px;">

</div>

<div class="gui-error-line"></div>
    `;

    $(body).html(html);

    /* add behaviors */

    setTimeout(() => {

      /* set a fresh directory tree */

      nbd.clearTree();

      // noinspection JSJQueryEfficiency
      $('#icb-dialog-fancytree').fancytree({

        extensions: ['dnd5', 'glyph', 'wide', 'filter', 'multi'],

        selectMode: 2,
        generateIds: true,
        idPrefix: '',

        source:    [
          {
            title: '/',
            key: '/',
            folder: true,
            expanded: true,
            lazy: true,
            children: null,
            icon: 'assets/images/blob-icons/blob-folder-20.png',
            type: 'folder'
          }
        ],

        lazyLoad: (event, data) => {

          const node: FancytreeNode = data.node;

          const dfd   = $.Deferred();
          data.result = dfd.promise();

          nbd.ls(node.key, dfd);
        },

        select: () => {

          nbd.error('');
          nbd.disable();
          nbd.validPlan    = false;
          nbd.type         = BlobType.None;
          nbd.fileOrfolder = '';

          const selection: FancytreeNode[] = nbd._tree.getSelectedNodes();

          if (selection.filter( (x: any) => {

            if (x.folder) {

              /* can pick a folder */

              return true;
            }

            /* otherwise, it's a file, and we want to only allow JSON files */

            const type: BlobType = Blob.typeofString(x.type);

            if (type == BlobType.Json) {

              return true;
            }

            return false;

          }).length > 0) {

            nbd.enable();
          }

          if (selection.length !== 1) {

            /* for multi-select we don't update the path field */

            return ;
          }

          const path: string   = selection[0].key;
          const type: BlobType = Blob.typeofString((selection[0] as any).type);

          /* if they select a JSON file, it may be batch plan file, so go and try to auto-detect that... */

          if (type == BlobType.Json) {

            Logger.debug("[NewCorridorBatchDialog] checking for plan file on: ", path);

            nbd.services.blobber.contents(path)
              .pipe(first())
              .subscribe(
                (content: string) => {

                  const name: string = BatchPlan.planName(content);

                  if (name != '') {

                    /* force the name for the batch, but still allow them to override it */

                    Logger.debug("[NewCorridorBatchDialog] auto-sensed batch name: ", name);

                    $(nbd.host).find('.batch-name-input').val(name);

                    nbd.name      = name;

                    nbd.validPlan = true;
                    nbd.type      = type;

                    nbd.validate();
                  }
                },
                (error) => {

                  Logger.error("[NewCorridorBatchDialog] can not open possible plan: ", path);
                });
          }

          /* update the path field */

          $(nbd.host).find('.icb-path-input').val(path);

          /* when they pick a new folder / file, re-validate */

          nbd.validate();
        },

        autoActivate: true,

        activeVisible: true,

        autoScroll: true,

        glyph: {
          preset: 'awesome5',
          map: {}
        },


      });

      // noinspection JSJQueryEfficiency
      nbd._tree = $('#icb-dialog-fancytree').fancytree('getTree');

      nbd.expandPathway(homePath);

    }, 50);

    $('#icb-home-click').on('click', () => {

      this.expandPathway(homePath);
    });

    $('#icb-projects-click').on('click', () => {

      nbd.expandPathway(projectPath);
    });

    $('#icb-quintiq-click').on('click', () => {

      nbd.tryPathway(quintiqPath);
    });

    $(nbd.host).find('.icb-path-input').on('input', (e) => {

      /* typing wait: @link https://stackoverflow.com/questions/10124114/wait-for-function-till-user-stops-typing */

      if (nbd.typingTimer) {

        clearTimeout(nbd.typingTimer);
      }

      nbd.typingTimer = setTimeout(() => {

        const path: string = $(e.currentTarget).val() as string;

        nbd.tryPath(path);

      }, 400);

    });

    $(nbd.host).find('.icb-path-input').on('keypress', (e) => {

      if (nbd.typingTimer) {

        clearTimeout(nbd.typingTimer);
      }

      nbd.typingTimer = setTimeout(() => {

        const path: string = ($(e.currentTarget).val() as string).trim();

        nbd.tryPath(path);

      }, 400);

    });

    $('input.icb-clone-kind[type=radio][name=type]').on('input', (e) => {

      nbd.validate();
    });

    setTimeout(() => {

      $(nbd.host).find('.batch-name-input').focus();

      $(nbd.host).find('.batch-name-input').on('input', (e) => {

        /* typing wait: @link https://stackoverflow.com/questions/10124114/wait-for-function-till-user-stops-typing */

        if (this.typingTimer) {

          clearTimeout(this.typingTimer);
        }

        nbd.typingTimer = setTimeout(() => {

          nbd.name = ($(e.currentTarget).val() as string).trim();

          nbd.validate();

        }, 400);

      });

      $(nbd.host).find('.batch-name-input').on('keypress', (e) => {

        if (nbd.typingTimer) {

          clearTimeout(nbd.typingTimer);
        }

        nbd.typingTimer = setTimeout(() => {

          nbd.name = ($(e.currentTarget).val() as string).trim();

          if (e.key.toLowerCase() === 'enter') {

            nbd.validate(true);

            /* stop event propagation */

            return false;
          }

        }, 400);

      });

    }, 50);

    /* disable the Ok button...until we have valid input */

    nbd.validate();
  }

  /** convenience to upgrade a string path to its pathway of keys */
  private tryPath(dir: string) {

    const path = dir.replace(new RegExp('[/]+$'), '');

    this.error('');

    const pathWay: string[] = [];
    const pieces:  string[] = path.split('/');
    const n:         number = pieces.length;

    for (let i = 0; i < n; i++) {

      /* build the next parent */

      let item = '';

      for (let j = 1; j <= i; j++) {

        item = item + '/' + pieces[j];

      }

      if (item === '') {
        continue;
      }

      pathWay.push(item);
    }

    this.expandPathway(pathWay);
  }

  /** before expanding a path, check if it even exists, and if not, error out */
  private tryPathway(segs: string[]) {

    const key: string = segs[segs.length - 1];

    this.services.blobber.fileordir(key)
      .pipe(first())
      .subscribe(
        item => {

          if (!item) {

            this.error(`Path does not exist (${key}).`);

            return ;
          }

          Logger.debug("[NewCorridorBatchDialog] expanding path: ", item);

          this.expandPathway(segs);
        },
        () => {

          this.error(`Path does not exist (${key}).`);
        });

  }

  /** expand the tree to a given point */
  private expandPathway(parents: string[]) {

    this._tree.getSelectedNodes().forEach(item => item.setSelected(false));

    let key: string        = '';
    let   n: FancytreeNode = null;
    let segs: string[]     = [];

    segs = segs.concat(parents);

    while (true) {

      if (segs.length === 0) {

        break;
      }

      key = segs.shift();
      n   = this._tree.getNodeByKey(key);

      if (n === null) {

        this.error(`Path does not exist (${key}).`);

        return;
      }

      if (n.children === null) {

        break;
      }
    }

    if (!n) {

      return ;
    }

    const pending = $.Deferred();

    pending.then((results) => {

        /* add the children */

        n.addChildren(results);
        n.setExpanded(true);
        n.setSelected(true);
        n.setActive(true);

        /* keep going */

        if (segs.length) {

          this.expandPathway(segs);

        } else {

          Logger.debug('[NewCorridorBatchDialog] done expanding path: ', n);

          this.validate();
        }
      },
      () => {

      });


    /* n.getParentList(true, true).forEach(x => x.toggleExpanded()); */

    n.setSelected(true);
    n.setActive(true);

    if (n.children === null) {

      this.ls(key, pending);
    }

  }

  /** list a directory in format suitable for FancyTree */
  private ls(path: string, dfd) {

    this.services.blobber.list(true, path, '/')
      .pipe(first())
      .subscribe(
        (listing: any) => {

          const results = [];

          listing.result.forEach((item) => {

            const name: string = item.name;
            const dir: string = path.replace(new RegExp('[/]+$'), '');

            if (item.file === false) {

              results.push({
                title: name,
                key: dir + '/' + name,
                folder: true,
                expanded: false,
                lazy: true,
                children: null,
                icon: 'assets/images/blob-icons/blob-folder-20.png',
                type: 'folder'
              });

            } else {

              let   icon: string   = 'assets/images/blob-icons/blob-file-20.png';
              const type: BlobType = Blob.typeofString(item.type);

              if (type !== BlobType.None) {

                icon = 'assets/images/blob-icons/' + Blob.iconOfType(type);
              }

              results.push({
                title:    name,
                key:      item.key,
                folder:   false,
                expanded: true,
                type:     item.type,
                icon
              });
            }

          });

          dfd.resolve(results);
        },
        error => {

          Logger.error('[NewCorridorBatchDialog] could not list folder: ', error);

          dfd.reject(error);
        });

    return [];
  }

  disable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).attr('disabled', 'true');
    $(ok).addClass('disabled');
  }

  enable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).removeAttr('disabled');
    $(ok).removeClass('disabled');

  }

  /** show a validation error */
  error(msg: string) {

    const display = $(this.host).find('.gui-error-line');

    $(display).html(msg);
  }

  /* don't enable the Ok button until we have what we need. */
  validate(transition: boolean = false) {

    this.error('');

    this.fileOrfolder = '';

    /* assume its bad */

    this.disable();

    if (this._tree === null) {

      return ;
    }

    const selection: FancytreeNode[] = this._tree.getSelectedNodes();

    if (selection.length == 0) {

      /* nothing to do, no folder selected */

      this.error('No import file/folder selected');

      return ;
    }

    const type: BlobType = Blob.typeofString((selection[0] as any).type);

    if (type != BlobType.Folder && type != BlobType.Json) {

      this.error('Must pick folder or batch plan (JSON file)');

      return ;
    }

    if (type == BlobType.Json) {

      /* must be a valid plan file */

      if (!this.validPlan) {

        this.error('Must pick valid plan file.');

        return ;
      }
    }

    this.fileOrfolder = selection[0].key

    if (this.name === '') {

      /* they have to pick a name for the new batch! */

      this.error('Batch name can not be empty.');

      return ;
    }

    if (!this.validator) {

      this.enable();

      /* if we make it through validation checks, and we're allowed to transition, then do it. */

      if (transition) {

        /* click the ok button for them, and trigger via ModelComponent */

        const ok = $(this.host).find('.modal-ok-button');

        $(ok).click();
      }

    } else {

      /* wrap validation in a promise, so its ok if its asynchronous */

      const p = new Promise((resolve, reject) => {

        this.validator({batch: this.name, src: this.fileOrfolder}, resolve, reject);

      }).then((data: any) => {

        this.enable();

        if (transition) {

          /* click the ok button for them, and trigger via ModelComponent */

          const ok = $(this.host).find('.modal-ok-button');

          $(ok).click();
        }

      }).catch((error) => {

        /* show the validation error */

        this.error(error);

      });

    }

  }

  /** dialog is closing */
  public close() {

    Logger.debug('[NewCorridorBatchDialog] closing...');

    this.clearTree();
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[NewCorridorBatchDialog] accepted: ');

    if (this.success) {

      this.success( {batch: this.name, src: this.fileOrfolder, validPlan: this.validPlan, type: this.type} );
    }

    this.clearTree();
  }

}
